import React, { Component } from 'react';
import { Table, Divider, Form, Button } from 'antd';
import axios from '../../service/index'
class WeightActivation extends Component {

	constructor(props) {
		super(props)
		this.state = {
			total: 0,
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			tableList: [],
			columns: [
				{
					title: '电话号码',
					dataIndex: 'phone',
					key: 'phone',
					align: 'center'
				},
				{
					title: '意向学科',
					dataIndex: 'intendedCourse',
					key: 'intendedCourse',
					align: 'center'
				},
				{
					title: '裂变人',
					dataIndex: 'kefuName',
					key: 'kefuName',
					align: 'center'
				},
				{
					title: '注册时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '使用时长',
					dataIndex: 'leanTime',
					key: 'leanTime',
					align: 'center'
				},
				{
					title: '学习天数',
					dataIndex: 'cumulativeDay',
					key: 'cumulativeDay',
					align: 'center'
				}
			]
		}
	}
	componentDidMount() {
		this.getTableList()
	}
	componentWillUnmount() {
		this.setState = () => false;
	}
	getTableList = () => {
		axios.post('userController/repeatedActivation', {
			...this.state.searchData
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					tableList: res.data.data.list,
					total: res.data.data.total
				})
			}
		})
	}
	exportData() {
		axios.get('/userController/repeatedActivationExport'
		, { responseType: 'blob' }).then(res => {
			const link = document.createElement('a')
			let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.setAttribute('download', '重量统计.xlsx')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		})
	}
	render() {
		const { tableList, columns, total} = this.state
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getTableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getTableList(searchData)
			},
		}
		return (
			<div className="userlist">
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>用户使用数据</span>
				
				<Divider />
				<div style={{display: 'flex', justifyContent: 'end'}}>
				<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.exportData()
						}}>导出</Button>
				</div>
				 <Table
						pagination={pagination}
						dataSource={tableList}
						columns={columns}
						rowKey={record => record.id} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
					/> 

				
			</div>
		)
	}

};

export default Form.create()(WeightActivation)